import { React, useEffect, useState } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Auth Pages
import Login from "./Pages/Login";
import LoginInternal from "./Pages/LoginInternal";
import RegisterPage from "./Pages/RegisterPage";
import ForgotPasswordPage from "./Pages/ForgotPassword";
import OtpPage from "./Pages/Otp";
import PropertyShareLink from "./Pages/Properties/PropertyShareLink";

// Layout Components
import SideNabar from "./Components/SideNavbar";
import TopNavbar from "./Components/TopNavbar";
import SalesSideNabar from "./Components/Sales/SideNavbar";
import FoodSideNabar from "./Components/Inventory/SideNavbar";
import Topbar from "./Components/Sales/Topbar";
import Logout from "./Components/Logout";

// Common Components
import NotfoundPage from "./Components/NotfoundPage";
import NoAccess from "./Pages/NoAccess";

// Dashboard Components
import DashBoardNew from "./Pages/Admin/DashBoardX";

// Dashboard for Complaints
import ComplaintsDashBoard from "./Pages/Complaints/Dashboard";
// import ComplaintAssignmentRules from "./Pages/Complaints/ComplaintAssignmentRules";

// Tenant Components
import TenantDetails from "./Pages/Tenants/TenantDetails";
import Tenants from "./Pages/Tenants/Tenants";
import Bookings from "./Pages/Tenants/Bookings";
import TenantsInactive from "./Pages/Tenants/TenantsInactive";
import TenantsAgreementExpiring from "./Pages/Tenants/TenantsAgreementExpiring";
import TenantsAgreement from "./Pages/Tenants/TenantsAgreement";
import MissedRent from "./Pages/Tenants/MissedRent";
import ReserveTenantListing from "./Pages/Tenants/ReserveTenantListing";
import MoveOutPendingTenantListing from "./Pages/Tenants/MoveOutPendingTenantsListing";
import TenantAttendance from "./Pages/Tenants/TenantAttendance";

// Property Components
import Properties from "./Pages/Properties/Properties";
import PropertyList from "./Pages/Properties/PropertyList";
import PropertyDetail from "./Pages/Properties/PropertyDetail";
import ViewBeds from "./Pages/Properties/ViewBeds";
import BedsView from "./Pages/PropertiesNew/List";
import BedsCalendar from "./Pages/PropertiesNew/BedsCalendar";
import AgreementsList from "./Pages/Properties/Lease/List";
import LandlordsAgreementExpiring from "./Pages/Properties/Lease/AgreementExpiring";
import LockinTracker from "./Pages/Properties/Lease/LockinTracker";
import ElectricityBill from "./Pages/Properties/ElectricityBill";
import PropertyExtraCharges from "./Pages/Properties/PropertyExtraCharges";
import VacancyByProperty from "./Pages/Properties/VacancyByProperty";

// Finance Components
import Expenses from "./Pages/Finance/Expenses";
import FinanceDues from "./Pages/Finance/Dues";
import FinanceTrans from "./Pages/Finance/Transactions";
import ExpenseSummary from "./Pages/Finance/ExpenseSummary";
import Refund from "./Pages/Finance/Refund";
import RecurringExpenses from "./Pages/Finance/RecurringExpenses";


// Admin Components
import Occupancy from "./Pages/Admin/Occupancy";
import Complaints from "./Pages/Admin/Complaints";
import Transactions from "./Pages/Admin/Transactions";
import RoomOptions from "./Pages/Admin/RoomOptions";
import Floors from "./Pages/Admin/Floors";
import OccupiedRooms from "./Pages/Admin/OccupiedRooms";
import Beds from "./Pages/Admin/Beds";
import BedsDetails from "./Pages/Admin/BedsDetails";
import ExtraCharges from "./Pages/Admin/ExtraCharges";
import SystemConfig from "./Pages/Admin/SystemConfig";
import { ExpensesType } from "./Pages/Admin/ExpensesType";
import Notifications from "./Pages/Admin/Notifications";
import AddBankPage from "./Pages/Admin/AddBankPage";
import AssetManagement from "./Pages/Admin/AssetManagement";
import AssetMaintenance from "./Pages/Admin/AssetMaintenance";
import Notice from "./Pages/Admin/Notice";
import FloorRoom from "./Pages/Admin/FloorRoom";
import IncomeExpenseSummary from "./Pages/Admin/IncomeExpenseSummary";
import VendorList from "./Pages/Admin/VendorList";
import VendorExpenseList from "./Pages/Admin/VendorExpenseList";
import Requests from "./Pages/Admin/Requests";
import IncomeAndExpenseDetails from "./Pages/Admin/IncomeAndExpenseDetails";
import DailySummary from "./Pages/Admin/DailySummary";
import Location from "./Pages/Admin/Location";
import PayableRent from "./Pages/Admin/PayableRent";

// Staff Components
import Staff from "./Pages/QuickActions/Staff";
import AdminStaff from "./Pages/QuickActions/AdminStaff";
import StaffDetail from "./Pages/QuickActions/StaffDetail";
import StaffAttendance from "./Pages/QuickActions/StaffAttendance";
import StaffCommission from "./Pages/QuickActions/StaffCommission";
import Partners from "./Pages/QuickActions/Partners";
import BankDetails from "./Pages/QuickActions/BankDetails";

// Sales Components
import Leads from "./Pages/Sales/Leads";
import FollowUpLeads from "./Pages/Sales/FollowUpLeads";
import VisitLeads from "./Pages/Sales/VisitLeads";

// Quick Actions
import ActivityLogs from "./Pages/QuickActions/ActivityLogs";
import FoodMenu from "./Pages/QuickActions/Food/FoodMenu";
import ViewTenantAttendance from "./Pages/QuickActions/ViewTenantAttendance";
import MarkTenantAttendance from "./Pages/QuickActions/MarkTenantAttendance";

// Settings & Reports
import Settings from "./Pages/Settings/Settings";
import Reports from "./Pages/Reports/Reports";
import CreateReports from "./Pages/Reports/CreateReport";
import OwnerDocuments from "./Pages/Settings/OwnerDocument";

// Assets
import Assets from "./Pages/Assets";

// Landlord Components
import LandlordDashboard from "./Pages/LandlordPortal/LandlordDashboard";
import LandlordPropertyList from "./Pages/LandlordPortal/PropertyList";
import LandlordDues from "./Pages/LandlordPortal/LandlordDues";
import LandlordCollection from "./Pages/LandlordPortal/LandlordCollection";
import ClientList from "./Pages/LandlordPortal/ClientList";
import StaffList from "./Pages/LandlordPortal/StaffList";
import LandlordAgreement from "./Pages/LandlordPortal/LandlordAgreement";
import LandlordTransactions from "./Pages/Landlords/Transactions";
import LandlordDetail from "./Pages/Landlords/Details/Details";
import PendingPayouts from "./Pages/Landlords/PendingPayouts";
import LandlordsList from "./Pages/Landlords/List";
import LandlordsPayments from "./Pages/Landlords/Payments";
import LandlordBankDetail from "./Pages/Landlords/LandlordBankDetail";

// Payout Components
import Beneficiaries from "./Pages/Payout/Beneficiaries";
import Transfers from "./Pages/Payout/Transfers";
import PayoutHistory from "./Pages/Payout/PayoutHistory";
import PayoutRecharge from "./Pages/Payout/PayoutRecharge";
import StaffWallet from "./Pages/Payout/StaffWallet";

// Food Components
import MealSummary from "./Pages/QuickActions/Food/MealSummary";
import MealParticipants from "./Pages/QuickActions/Food/MealParticipants";
import TenantService from "./Pages/QuickActions/Food/TenantService";

// Other Components
import StampPaperListingNew from "./Pages/QuickActions/StampPaperListingNew";
import BookingList from "./Pages/Bookings/BookingList";

// Utilities
import ProtectedRoute from "./utilities/ProtectedRoute";
import { Remove_User } from "./Redux/actions";
import "./i18";
import Config from "./Config";
import SalesHeadDashboard from "./Pages/Sales/Dashboard";

import FoodDashboard from "./Pages/Food/Dashboard";
import FoodInventory from "./Pages/Food/Inventory";
import InventoryStock from "./Pages/Food/InventoryStock";
import StockTransfers from "./Pages/Food/StockTransfers";
import TransferedItems from "./Pages/Food/TransferedItems";
import PurchaseInventory from "./Pages/Food/PurchaseInventory";
import FoodItems from "./Pages/Food/FoodItems";
import KitchenList from "./Pages/Food/KitchenList";
import AutoPay from "./Pages/Payout/AutoPay";
import Housekeeping from "./Pages/Inspection/Housekeeping";
import TenantList from "./Pages/LandlordPortal/TenantList";
// import RentAgreement from "./Pages/Settings/RentAgreement";

function App() {
  const user = useSelector((state) => state.UserReducer.user);
  const isSessionExpired = user?.expireAt && Date.now() >= Number(user.expireAt);
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showLogoutModal, setShowLogoutModal] = useState(false);


  const isSalesPerson = user &&
    (user?.role === Config.STAFF_ROLES.SALES_HEAD || user?.role === Config.STAFF_ROLES.SALESPERSON) &&
    user?.userType === Config.USER_TYPE.STAFF;

  const isKitchenManager = user &&
    user?.role === Config.STAFF_ROLES.KITCHEN_MANAGER &&
    user?.userType === Config.USER_TYPE.STAFF;

  const isMaintenanceTeam =
    user &&
    user?.role === Config.STAFF_ROLES.MAINTENANCE_SUPERVISOR &&
    user?.userType === Config.USER_TYPE.STAFF;

  //useEffect(() => isSessionExpired(), []);
  useEffect(() => {
    if (!user?.expireAt) return;

    const delay = user.expireAt - Date.now();

    if (delay <= 0) {
      setShowLogoutModal(false);
      dispatch(Remove_User());
      navigate("/", { replace: true });
      return;
    }

    const timer = setTimeout(() => {
      setShowLogoutModal(false);
      dispatch(Remove_User());
      navigate("/", { replace: true });
    }, delay);

    return () => clearTimeout(timer);
  }, [user?.expireAt]);

  // ToastContainer configuration
  const toastConfig = {
    position: "top-center",
    autoClose: 2000,
    hideProgressBar: true,
    newestOnTop: true,
    closeOnClick: true,
    pauseOnFocusLoss: false,
    draggable: true,
    pauseOnHover: false,
  };

  // Common Routes for all authenticated users
  const commonRoutes = (
    <>
      {/* <Route path="/login" element={<Login />} /> */}
      <Route path="*" element={<NotfoundPage />} />
    </>
  );

  // Maintenance Routes
  const maintenanceRoutes = (
    <>
      <Route path="/" element={<ComplaintsDashBoard />} />
      <Route path="/dashboard" element={<ComplaintsDashBoard />} />
      <Route path="/complaints" element={<Complaints />} />
      <Route path="*" element={<NotfoundPage />} />
      {/* Assets */}
      <Route
        path="/assets"
        element={
          <ProtectedRoute permission="MANANGE_PROPERTY_ASSETS">
            <Assets />
          </ProtectedRoute>
        }
      />
    </>
  );

  // Salesperson Routes
  const salesPersonRoutes = (
    <>
      <Route path="/" element={<SalesHeadDashboard />} />
      <Route path="/dashboard" element={<SalesHeadDashboard />} />
      <Route
        path="/leads"
        element={
          <ProtectedRoute permission="MANANGE_LEADS">
            <Leads />
          </ProtectedRoute>
        }
      />
      <Route
        path="/leads/followups"
        element={
          <ProtectedRoute permission="MANANGE_LEADS">
            <FollowUpLeads />
          </ProtectedRoute>
        }
      />
      <Route
        path="/leads/visits"
        element={
          <ProtectedRoute permission="MANANGE_LEADS">
            <VisitLeads />
          </ProtectedRoute>
        }
      />

      <Route path="/bookings" element={<BookingList />} />
      <Route path="/property-list" element={<PropertyList />} />
      <Route path="/property-detail" element={<PropertyDetail />} />
      <Route path="/beds-view" element={<BedsView />} />
      <Route path="/property/rooms" element={<ViewBeds />} />
      <Route
        path="/vacancy-by-property"
        element={<VacancyByProperty />}
      />
      {/* Vendor Routes */}
      <Route path="/vendors" element={<VendorList />} />
      <Route path="/vendors-expense/:vendorId" element={<VendorExpenseList />} />
      <Route path="/inventory" element={<ViewBeds />} />
      <Route
        path="/tenantdetails/:t/:id/:e?"
        element={<TenantDetails key={location.pathname} />}
      />
      <Route
        path="/tenants/active"
        element={
          <ProtectedRoute permission="MANANGE_TENANTS">
            <Tenants />
          </ProtectedRoute>
        }
      />
      <Route
        path="/tenants/moved-out"
        element={
          <ProtectedRoute permission="MANANGE_TENANTS">
            <TenantsInactive />
          </ProtectedRoute>
        }
      />
      <Route
        path="/tenants/expiring-agreements"
        element={
          <ProtectedRoute permission="MANANGE_TENANTS">
            <TenantsAgreementExpiring />
          </ProtectedRoute>
        }
      />
      <Route
        path="/tenants/agreement"
        element={<TenantsAgreement />}
      />
      <Route
        path="/missed-rent"
        element={<MissedRent />}
      />
      <Route
        path="/reserve/tenants"
        element={<ReserveTenantListing />}
      />
      <Route
        path="/moveout/pendingTenants"
        element={<MoveOutPendingTenantListing />}
      />
      <Route
        path="/tenant-attendance/:tenantId"
        element={
          <ProtectedRoute permission="MANANGE_ATTENDANCES">
            <TenantAttendance />
          </ProtectedRoute>
        }
      />
      <Route
        path="/view-attendance"
        element={
          <ProtectedRoute permission="MANANGE_ATTENDANCES">
            <ViewTenantAttendance />
          </ProtectedRoute>
        }
      />
      <Route
        path="/mark-attendance/:id"
        element={
          <ProtectedRoute permission="MANANGE_ATTENDANCES">
            <MarkTenantAttendance />
          </ProtectedRoute>
        }
      />
      <Route
        path="/staffs"
        element={
          <ProtectedRoute permission="MANANGE_STAFF">
            <AdminStaff />
          </ProtectedRoute>
        }
      />
      <Route
        path="/staff/attendance/:staffId"
        element={
          <ProtectedRoute permission="MANANGE_ATTENDANCES">
            <StaffAttendance />
          </ProtectedRoute>
        }
      />
      <Route path="/staff-commission" element={<StaffCommission />} />
      <Route path="/staff-detail" element={<StaffDetail />} />
      <Route path="/reports" element={<Reports />} />
      <Route path="/create-reports" element={<CreateReports />} />
      <Route path="/settings" element={<Settings />} />
      <Route
        path="/documents-vault"
        element={
          <ProtectedRoute permission="MANAGE_DOCUMENTS">
            <OwnerDocuments />
          </ProtectedRoute>
        }
      />
    </>
  );

  // Kitchen Routes
  const kitchenManagerRoutes = (
    <>
      <Route path="/" element={<FoodDashboard />} />
      <Route path="/dashboard" element={<FoodDashboard />} />
      <Route path="/food-inventory" element={<FoodInventory />} />
      <Route path="/property-list" element={<PropertyList />} />
      <Route path="/beds-view" element={<BedsView />} />
      <Route path="/property-detail" element={<PropertyDetail />} />
      <Route path="/property/rooms" element={<ViewBeds />} />
      <Route path="/food-menu" element={<FoodMenu />} />
      <Route path="/meal-summary" element={<MealSummary />} />
      <Route path="/meal-participants" element={<MealParticipants />} />
      <Route path="/tenant-service" element={<TenantService />} />
      {/* Vendor Routes */}
      <Route path="/vendors" element={<VendorList />} />
      <Route path="/vendors-expense/:vendorId" element={<VendorExpenseList />} />
      <Route
        path="/complaints"
        element={
          <Complaints />
        }
      />
      <Route path="/inventory" element={<ViewBeds />} />

      <Route path="/payouts/beneficiaries" element={<Beneficiaries />} />

      <Route path="/payouts/transfers" element={<Transfers />} />
      <Route path="/payout/history/:id" element={<PayoutHistory />} />
      <Route path="/payout/recharge" element={<PayoutRecharge />} />

      <Route path="/reports" element={<Reports />} />
      <Route path="/create-reports" element={<CreateReports />} />
      <Route path="/settings" element={<Settings />} />
      {/* Food Inventory */}
      <Route path="/inventory-stock" element={<InventoryStock />} />
      <Route path="/stock-transfers" element={<StockTransfers />} />
      <Route path="/transfered-items" element={<TransferedItems />} />
      <Route path="/purchase-inventory" element={<PurchaseInventory />} />
      <Route path="/kitchens" element={<KitchenList />} />
      <Route path="/food-items" element={<FoodItems />} />
    </>
  );

  // Regular Routes (for non-salesperson users)
  const regularRoutes = (
    <>
      {/* <Route path="/" element={<DashBoardNew />} /> */}
      <Route path="/" element=
        {
          // <ProtectedRoute permission="MANANGE_TENANTS">
          <DashBoardNew />
          // </ProtectedRoute>
        }
      />
      <Route path="/dashboard" element=
        {
          <DashBoardNew />
        }
      />

      {/* Tenant Routes */}
      <Route
        path="/tenantdetails/:t/:id/:e?"
        element={<TenantDetails key={location.pathname} />}
      />
      <Route
        path="/tenants/active"
        element={
          <ProtectedRoute permission="MANANGE_TENANTS">
            <Tenants />
          </ProtectedRoute>
        }
      />
      <Route path="/tenants/bookings" element={<Bookings />} />
      <Route
        path="/tenants/moved-out"
        element={
          <ProtectedRoute permission="MANANGE_TENANTS">
            <TenantsInactive />
          </ProtectedRoute>
        }
      />
      {/* <Route
        path="/complaints/assignment-rules"
        element={<ComplaintAssignmentRules />}
      /> */}
      <Route
        path="/tenants/expiring-agreements"
        element={
          <ProtectedRoute permission="MANANGE_TENANTS">
            <TenantsAgreementExpiring />
          </ProtectedRoute>
        }
      />
      <Route
        path="/tenants/agreement"
        element={<TenantsAgreement />}
      />
      <Route
        path="/missed-rent"
        element={<MissedRent />}
      />
      <Route
        path="/reserve/tenants"
        element={<ReserveTenantListing />}
      />
      <Route
        path="/moveout/pendingTenants"
        element={<MoveOutPendingTenantListing />}
      />
      <Route
        path="/tenant-attendance/:tenantId"
        element={
          <ProtectedRoute permission="MANANGE_ATTENDANCES">
            <TenantAttendance />
          </ProtectedRoute>
        }
      />

      {/* Property Routes */}
      <Route
        path="/properties"
        element={
          <ProtectedRoute permission="MANANGE_INVENTORY">
            <Properties />
          </ProtectedRoute>
        }
      />
      <Route path="/property-list" element={<PropertyList />} />
      <Route path="/property-detail" element={<PropertyDetail />} />
      <Route path="/property/rooms" element={<ViewBeds />} />
      <Route path="/inventory" element={<ViewBeds />} />
      <Route
        path="/properties/agreements"
        element={<AgreementsList />}
      />
      <Route
        path="/properties/expiring-agreements"
        element={<LandlordsAgreementExpiring />}
      />
      <Route
        path="/properties/lockin-tracker"
        element={<LockinTracker />}
      />
      <Route
        path="/properties/pending-exp"
        element={
          <ProtectedRoute permission="MANANGE_EXPENSES">
            <RecurringExpenses />
          </ProtectedRoute>
        }
      />
      <Route path="/electricity-bill" element={<ElectricityBill />} />
      <Route
        path="/property-extra-charges"
        element={<PropertyExtraCharges />}
      />
      <Route
        path="/vacancy-by-property"
        element={<VacancyByProperty />}
      />

      {/* Admin Routes */}
      <Route path="/occupancy/:id" element={<Occupancy />} />
      <Route path="roomoptions/:id" element={<RoomOptions />} />
      <Route path="floors/:id" element={<Floors />} />
      <Route path="beds/:roomId" element={<Beds />} />
      <Route path="beddetails/:id" element={<BedsDetails />} />
      <Route path="occupiedroom/:propId/:roomId" element={<OccupiedRooms />} />
      <Route path="extracharges" element={
        <ProtectedRoute permission="MANANGE_EXTRACHARGES">
          <ExtraCharges />
        </ProtectedRoute>
      } />
      <Route path="/systemconfig" element={<SystemConfig />} />
      <Route path="/expensestype" element={<ExpensesType />} />
      <Route path="/notifications/:id" element={<Notifications />} />
      <Route path="/bank/:clientId" element={<AddBankPage />} />
      <Route path="/assets-management" element={<AssetManagement />} />
      <Route
        path="/asset/list/maintenance/:assetId/:propId"
        element={<AssetMaintenance />}
      />
      <Route path="/notice" element={
        <ProtectedRoute permission="MANANGE_SENDNOTICES">
          <Notice />
        </ProtectedRoute>
      } />
      <Route path="/manage-flats-floors" element={<FloorRoom />} />
      <Route path="/props-financial-summary" element={<IncomeExpenseSummary />} />
      <Route path="/income-expense" element={<IncomeAndExpenseDetails />} />
      <Route path="/daily-summary/:p?" element={<DailySummary />} />
      <Route path="/location" element={<Location />} />
      <Route path="/payable-rent" element={<PayableRent />} />

      {/* Finance Routes */}
      <Route
        path="/finance/dues/"
        element={
          <ProtectedRoute permission="MANANGE_DUES">
            <FinanceDues />
          </ProtectedRoute>
        }
      />
      <Route
        path="/finance/collections/"
        element={
          <ProtectedRoute permission="MANANGE_COLLECTIONS">
            <FinanceTrans />
          </ProtectedRoute>
        }
      />
      <Route
        path="/finance/expenses/"
        element={
          <ProtectedRoute permission="MANANGE_EXPENSES">
            <Expenses />
          </ProtectedRoute>
        }
      />
      <Route
        path="/finance/expenses/pending"
        element={
          <ProtectedRoute permission="MANANGE_EXPENSES">
            <RecurringExpenses />
          </ProtectedRoute>
        }
      />
      <Route path="/expense-summary" element={<ExpenseSummary />} />
      <Route
        path="/finance/refund"
        element={
          <ProtectedRoute permission="MANANGE_EXPENSES">
            <Refund />
          </ProtectedRoute>
        }
      />

      {/* Complaint Routes */}
      <Route
        path="/property/complaints"
        element={
          <ProtectedRoute permission="MANANGE_COMPLAINTS">
            <Complaints />
          </ProtectedRoute>
        }
      />
      <Route
        path="/complaints"
        element={
          <ProtectedRoute permission="MANANGE_COMPLAINTS">
            <Complaints />
          </ProtectedRoute>
        }
      />

      {/* Staff Routes */}
      <Route path="/staff/:clientId" element={<Staff />} />
      <Route
        path="/staffs"
        element={
          <ProtectedRoute permission="MANANGE_STAFF">
            <AdminStaff />
          </ProtectedRoute>
        }
      />
      <Route path="/staff-detail" element={<StaffDetail />} />
      <Route
        path="/staff/attendance/:staffId"
        element={
          <ProtectedRoute permission="MANANGE_ATTENDANCES">
            <StaffAttendance />
          </ProtectedRoute>
        }
      />
      <Route path="/staff-commission" element={<StaffCommission />} />
      <Route
        path="/bank-details"
        element={
          <ProtectedRoute permission="MANANGE_BANKS">
            <BankDetails />
          </ProtectedRoute>
        }
      />
      {user?.userType === 1 && (
        <Route
          path="/partners"
          element={
            <ProtectedRoute permission="MANANGE_STAFF">
              <Partners />
            </ProtectedRoute>
          }
        />
      )}

      {/* Sales Routes */}
      <Route
        path="/leads"
        element={
          <ProtectedRoute permission="MANANGE_LEADS">
            <Leads />
          </ProtectedRoute>
        }
      />
      <Route
        path="/leads/followups"
        element={
          <ProtectedRoute permission="MANANGE_LEADS">
            <FollowUpLeads />
          </ProtectedRoute>
        }
      />
      <Route
        path="/leads/visits"
        element={
          <ProtectedRoute permission="MANANGE_LEADS">
            <VisitLeads />
          </ProtectedRoute>
        }
      />

      {/* Quick Actions */}
      <Route path="/activity-logs" element={<ActivityLogs />} />
      <Route path="/food-menu" element={<FoodMenu />} />
      <Route
        path="/view-attendance"
        element={
          <ProtectedRoute permission="MANANGE_ATTENDANCES">
            <ViewTenantAttendance />
          </ProtectedRoute>
        }
      />
      <Route
        path="/mark-attendance/:id"
        element={
          <ProtectedRoute permission="MANANGE_ATTENDANCES">
            <MarkTenantAttendance />
          </ProtectedRoute>
        }
      />

      {/* Settings & Reports */}
      <Route path="/settings" element={<Settings />} />
      <Route
        path="/reports"
        element={
          <ProtectedRoute permission="MANANGE_REPORTS">
            <Reports />
          </ProtectedRoute>
        }
      />
      <Route
        path="/create-reports"
        element={
          <ProtectedRoute permission="MANANGE_REPORTS">
            <CreateReports />
          </ProtectedRoute>
        }
      />
      <Route
        path="/documents-vault"
        element={
          <ProtectedRoute permission="MANAGE_DOCUMENTS">
            <OwnerDocuments />
          </ProtectedRoute>
        }
      />
      {/* <Route path="/rent-agreement" element={<RentAgreement />} /> */}
      {/* Assets */}
      <Route
        path="/assets"
        element={
          <ProtectedRoute permission="MANANGE_PROPERTY_ASSETS">
            <Assets />
          </ProtectedRoute>
        }
      />

      {/* Vendor Routes */}
      <Route path="/vendors" element={<VendorList />} />
      <Route path="/vendors-expense/:vendorId" element={<VendorExpenseList />} />

      {/* Request & Booking Routes */}
      <Route
        path="/requests"
        element={
          <ProtectedRoute permission="MANANGE_REQUESTS">
            <Requests />
          </ProtectedRoute>
        }
      />
      <Route
        path="/bookings"
        element={
          <ProtectedRoute permission="MANANGE_TENANTS">
            <BookingList />
          </ProtectedRoute>
        }
      />

      {/* Transaction Routes */}
      <Route path="/transactions/:tenantId" element={<Transactions />} />

      {/* Landlord Routes */}
      <Route
        path="/landlord/transactions"
        element={
          <ProtectedRoute permission="MANANGE_LANDLORD">
            <LandlordTransactions />
          </ProtectedRoute>
        }
      />
      <Route
        path="/landlord/details"
        element={
          <ProtectedRoute permission="MANANGE_LANDLORD">
            <LandlordDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path="/landlord/pending-payouts"
        element={
          <ProtectedRoute permission="MANANGE_LANDLORD">
            <PendingPayouts />
          </ProtectedRoute>
        }
      />
      <Route
        path="/landlords"
        element={
          <ProtectedRoute permission="MANANGE_LANDLORD">
            <LandlordsList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/landlords/payments"
        element={
          <ProtectedRoute permission="MANANGE_LANDLORD">
            <LandlordsPayments />
          </ProtectedRoute>
        }
      />
      <Route path="/landlord/bank-details" element={<LandlordBankDetail />} />
      <Route path="/landlord/dashboard" element={<LandlordDashboard />} />
      <Route path="/landlord/property-list" element={<LandlordPropertyList />} />
      <Route path="/landlord/dues" element={<LandlordDues />} />
      <Route path="/landlord/collections" element={<LandlordCollection />} />
      <Route path="/landlord/client" element={<ClientList />} />
      <Route path="/landlord/client/tenants" element={<TenantList />} />
      <Route path="/landlord/staffs" element={<StaffList />} />
      <Route path="/landlord/agreement" element={<LandlordAgreement />} />
      <Route path="/beds-view" element={<BedsView />} />
      <Route path="/beds-calendar" element={<BedsCalendar />} />

      {/* Payout Routes */}
      <Route path="/payouts/beneficiaries" element={<Beneficiaries />} />
      <Route path="/payouts/staff-wallet" element={<StaffWallet />} />
      <Route path="/payouts/autopay" element={<AutoPay />} />
      <Route path="/payouts/transfers" element={<Transfers />} />
      <Route path="/payout/history/:id" element={<PayoutHistory />} />
      <Route path="/payout/recharge" element={<PayoutRecharge />} />

      {/* Food Routes */}
      <Route path="/meal-summary" element={<MealSummary />} />
      <Route path="/meal-participants" element={<MealParticipants />} />
      <Route path="/tenant-service" element={<TenantService />} />

      {/* Stamp Paper */}
      <Route path="/stamp-paper" element={<StampPaperListingNew />} />

      {/* Food Inventory */}
      <Route path="/inventory-stock" element={<InventoryStock />} />
      <Route path="/stock-transfers" element={<StockTransfers />} />
      <Route path="/transfered-items" element={<TransferedItems />} />
      <Route path="/purchase-inventory" element={<PurchaseInventory />} />
      <Route path="/kitchens" element={<KitchenList />} />
      <Route path="/food-items" element={<FoodItems />} />
      <Route path="/housekeeping" element={<Housekeeping />} />

      {/* No Access */}
      <Route path="/no-access" element={<NoAccess />} />
    </>
  );

  // If user is not logged in
  if (!user || isSessionExpired) {
    return (
      <>
        <ToastContainer {...toastConfig} />
        <Routes>
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/get-otp" element={<OtpPage />} />
          <Route path="*" index element={<Login />} />
          <Route path="/login-internal" element={<LoginInternal />} />
          <Route path="/property/:gId" element={<PropertyShareLink />} />
        </Routes>
      </>
    );
  }

  // If user is a salesperson
  if (isSalesPerson) {
    return (
      <>
        {showLogoutModal && (
          <Logout isLogout={showLogoutModal} setIsLogout={setShowLogoutModal} />
        )}
        <div className="flex h-screen overflow-hidden">
          <ToastContainer {...toastConfig} />
          <SalesSideNabar onLogoutClick={() => setShowLogoutModal(true)} />
          <div className="flex flex-col flex-1 overflow-hidden">
            <Topbar />
            <div className="flex-1 overflow-y-auto bg-[#F6F7F8] rounded-2xl">
              <Routes>
                {commonRoutes}
                {salesPersonRoutes}
              </Routes>
            </div>
          </div>
        </div>
      </>
    );
  }

  if (isMaintenanceTeam) {
    return (
      <>
        {showLogoutModal && (
          <Logout
            isLogout={showLogoutModal}
            setIsLogout={setShowLogoutModal}
          />
        )}

        <div className="flex h-screen overflow-hidden">
          <ToastContainer {...toastConfig} />

          <SideNabar
            onLogoutClick={() => setShowLogoutModal(true)}
          />

          <div className="flex flex-1 flex-col overflow-hidden">
            <TopNavbar />

            <div className="flex-1 overflow-y-auto rounded-2xl bg-[#F6F7F8]">
              <Routes>
                {maintenanceRoutes}
              </Routes>
            </div>
          </div>
        </div>
      </>
    );
  }

  if (isKitchenManager) {
    return (
      <>
        {showLogoutModal && (
          <Logout isLogout={showLogoutModal} setIsLogout={setShowLogoutModal} />
        )}
        <div className="flex h-screen overflow-hidden">
          <ToastContainer {...toastConfig} />
          <FoodSideNabar onLogoutClick={() => setShowLogoutModal(true)} />
          <div className="flex flex-col flex-1 overflow-hidden">
            <Topbar />
            <div className="flex-1 overflow-y-auto bg-[#F6F7F8] rounded-2xl">
              <Routes>
                {commonRoutes}
                {kitchenManagerRoutes}
              </Routes>
            </div>
          </div>
        </div>
      </>
    );
  }

  // Regular user (default)
  return (
    <>
      {showLogoutModal && (
        <Logout isLogout={showLogoutModal} setIsLogout={setShowLogoutModal} />
      )}
      <div className="flex h-screen overflow-hidden">
        <ToastContainer {...toastConfig} />
        <SideNabar onLogoutClick={() => setShowLogoutModal(true)} />
        <div className="flex flex-col flex-1 overflow-hidden">
          <TopNavbar />
          <div className="flex-1 overflow-y-auto bg-[#F6F7F8] rounded-2xl">
            <Routes>
              {commonRoutes}
              {regularRoutes}
            </Routes>
          </div>
        </div>
      </div>
    </>
  );
}

export default App;
